import GoogleTagManager from '@redux-beacon/google-tag-manager';
import logger from '@redux-beacon/logger';
import { createMiddleware } from 'redux-beacon';
const originalGtmTarget = GoogleTagManager();
const canUseDOM = 
// eslint-disable-next-line unicorn/no-typeof-undefined -- window is defined in the global scope
typeof window !== 'undefined' &&
    !!window.document &&
    !!window.document.createElement;
const gtmTarget = (...args) => {
    // original target throws an error if dataLayer isn't loaded (yet),
    // we don't want that. Let's rather push events onto the stack
    // and assume that it will load eventually.
    // Worst case would be the tracking not working,
    // but that's better than the whole page crashing...
    if (canUseDOM && !window.dataLayer) {
        window.dataLayer = [];
    }
    return originalGtmTarget(...args);
};
const options = process.env.STAGE === 'prod' ? {} : { logger };
export const middleware = (eventsMap) => {
    return createMiddleware(eventsMap, gtmTarget, options);
};
//# sourceMappingURL=middleware.js.map